/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
import React, { useCallback, useEffect, useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";
import { LOAN_PROVIDER } from "../../../constants/app-constants";
import PostBcMyBookingCarCard from "../../shared/post-bc-my-booking-car-card";
import PostBcDepositPaidSection from "../../shared/post-bc-deposit-paid-section/component";
import PriceBreakupModal from "../price-breakup-modal";
import DriveAwayPriceModal from "../drive-away-price-modal-revamp/component";

const TYPE = {
    DEPOSIT: "deposit"
};

// eslint-disable-next-line max-statements
const CarDeliveryDateCard = ({ content = {}, config = {}, paymentSummaryData, financeProvider, showNumberAnimation, frequency = "week", orderId, updatePaymentSummaryStatusConnect }) => {

    const { deposit } = paymentSummaryData || {};
    const [loading, setLoading] = useState(false);
    const {show} = deposit || {};
    const [showPriceModal, setShowPriceModal] = useState(false);
    const [showDriveAwayPriceModal, setShowDriveAwayPriceModal] = useState(false);
    const handleUpdatePaymentSummaryStatus = useCallback(async () => {
        setLoading(true);
        await updatePaymentSummaryStatusConnect(TYPE.DEPOSIT);
        setLoading(false);
    }, [updatePaymentSummaryStatusConnect]);

    useEffect(() => {
        if (show) {
            handleUpdatePaymentSummaryStatus();
        }
    }, [handleUpdatePaymentSummaryStatus, show]);

    const isFinanceUser = financeProvider === LOAN_PROVIDER.CARS24;
    const emi = paymentSummaryData?.repayment?.emi;
    const { amountDue, totalAmountToCollect, totalLoanAmount = 0 } = paymentSummaryData || {};

    const carAmountLabel = isFinanceUser
        ? "Loan amount"
        : amountDue === 0
            ? "Drive away price"
            : "Amount due";

    const totalAmount = isFinanceUser
        ? totalLoanAmount
        : amountDue === 0
            ? totalAmountToCollect
            : amountDue;

    const hasMainImage = content.mainImage && content.mainImage.path && config && config.imageHost ? true : false;
    const carImageUrl = hasMainImage
        ? fastlyUrl(config.imageHost, content.mainImage.path, imageTypes.auCarCheckoutThumbnail)
        : null;
    const handleOpenPriceBreakDownModal = () => {
        if (paymentSummaryData?.reconcilePending && !isFinanceUser) {
            setShowDriveAwayPriceModal(true);
        } else {
            setShowPriceModal(true);
        }
    };
    return (
        <React.Fragment>
            <div styleName={"styles.outer"}>

                <PostBcMyBookingCarCard
                    carAmountLabel={carAmountLabel}
                    totalLoanAmount={totalAmount}
                    emi={emi}
                    showNumberAnimation={showNumberAnimation}
                    frequency={frequency}
                    orderId={orderId}
                    carImageUrl={carImageUrl}
                    isFinanceUser={isFinanceUser}
                    handleOpenPriceBreakDownModal={handleOpenPriceBreakDownModal}

                />
                {showDriveAwayPriceModal && <DriveAwayPriceModal onClose={() => setShowDriveAwayPriceModal(false)} />}
                <PriceBreakupModal isOpen={showPriceModal} onClose={() => setShowPriceModal(false)} />
            </div>
            {show && !loading && (
                <div styleName={"styles.statusWrapper"}>
                    <PostBcDepositPaidSection paymentSummaryData={paymentSummaryData} updatePaymentSummaryStatusConnect={updatePaymentSummaryStatusConnect} orderId={orderId} />
                </div>
            )}
        </React.Fragment>
    );
};

CarDeliveryDateCard.propTypes = {
    paymentSummaryData: PropTypes.object,
    content: PropTypes.object,
    config: PropTypes.object,
    frequency: PropTypes.string,
    financeProvider: PropTypes.string,
    showNumberAnimation: PropTypes.bool,
    splitPaymentOpted: PropTypes.bool,
    orderId: PropTypes.string,
    updatePaymentSummaryStatusConnect: PropTypes.func
};
export default CarDeliveryDateCard;
